import React from 'react';
import { useParams } from 'react-router-dom';
import GetRequest from '../Services/APIRequest';
import Loading from '../Components/Loading';
import Error from '../Components/Error';

const OrderDetails = () => {
    const Id = useParams();
    const { data, error, isLoaded } = GetRequest(`/Orders/GetOrderLineDetailsById/${Id.Id}`);

    if (error !== null) {
        return <Error data=" " />;
    }
    if (!isLoaded) {
        return <Loading />;
    }

    return (
        <>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3 className="card-title">{data.result && data.result.orderNumber}</h3>
                                </div>
                                <div className="card-body">
                                    <p>Status - <b>{data.result.statusDisplayText}</b></p>
                                    <p>Ship To - <b>{data.result.shipToDetails}</b></p>

                                    <div className="col-sm-12">
                                        <p>Remarks: <b>{data.result.orderComments}</b></p>
                                        <p>Approval Comments: <b>{data.result.orderStatusChangeComments}</b></p>
                                        {data.result.orderApprovedBy && (
                                            <p>Approved by: <b>{data.result.orderApprovedBy}</b></p>
                                        )}
                                    </div>

                                    {data.result.orders && data.result.orders.map((item, index) => (
                                        <div className="row" key={index}>
                                            <div className="col-md-12">
                                                <div className="card">
                                                    <div className="card-header bg-info">
                                                        <h5 className="card-title">
                                                            {/* {item.companyName} Order ({item.numberOfItemsDispatched}/{item.numberOfItems}) */}
                                                            {item.companyName} Items
                                                        </h5>
                                                    </div>
                                                    <div className="card-body">


                                                        {item.orderLineItemDTOList && item.orderLineItemDTOList.map((items, idx) => {
                                                            const progressPercentage =
                                                                (items.dispatchedQuantity / items.totalQuantityOrdered) * 100;

                                                            let progressBarWidth = 100;
                                                            let progressColor = "bg-warning";

                                                            if (progressPercentage === 100) {
                                                                progressColor = "bg-success";
                                                                progressBarWidth = 100;
                                                            } else if (progressPercentage >= 50) {
                                                                progressColor = "bg-warning";
                                                                progressBarWidth = 100 - progressPercentage;
                                                            } else if (progressPercentage === 0) {
                                                                progressColor = "bg-danger";
                                                                progressBarWidth = 100;
                                                            }

                                                            return (
                                                                <div key={idx} className="mb-3 p-3 border rounded bg-light">
                                                                    <div className="d-flex justify-content-between">
                                                                        <h6 className="mb-1">{items.productName}</h6>
                                                                        <span>
                                                                            <b>{items.dispatchedQuantity} / {items.totalQuantityOrdered}</b>
                                                                        </span>
                                                                    </div>

                                                                    <div className="progress progress-sm">
                                                                        <div
                                                                            className={`progress-bar ${progressColor}`}
                                                                            role="progressbar"
                                                                            style={{
                                                                                width: `${items.totalQuantityOrdered > 0 ? progressBarWidth : 100}%`,
                                                                                backgroundColor: items.totalQuantityOrdered > 0 ? '' : '#dc3545'
                                                                            }}
                                                                            aria-valuenow={progressPercentage}
                                                                            aria-valuemin="0"
                                                                            aria-valuemax="100"
                                                                        >
                                                                            {items.totalQuantityOrdered > 0 ? `${Math.round(progressPercentage)}%` : "Preclosed / Cancelled"}
                                                                        </div>
                                                                    </div>

                                                                    {/* Show Preclose Details if isPreClosed is true */}
                                                                    {items.isPreClosed && (
                                                                        <div className="mt-2 p-2 border rounded bg-light">
                                                                            <h6 className="text-danger">Preclosed Details</h6>
                                                                            <p><b>Quantity:</b> {items.preCloseQty}</p>
                                                                            <p><b>Date:</b> {items.preCloseDate}</p>
                                                                            <p><b>Reason:</b> {items.preCloseReason}</p>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            );
                                                        })}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default OrderDetails;
